module.exports = __webpack_public_path__ + "img/btn-SMNP.5d40784a.png";